var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36614 59.4411C8.79061 59.5739 8.20653 59.6939 7.61099 59.8022C6.12681 60.0722 4.57144 60.2697 2.89962 60.4119C2.84184 60.4168 2.7839 60.4216 2.72584 60.4264C2.60221 60.4337 2.48502 60.4387 2.37398 60.4415C2.37393 60.4415 2.37388 60.4416 2.37383 60.4416C-0.713972 60.5206 0.945169 58.941 0.945169 58.941C0.945169 58.941 1.5392 58.1517 2.43618 56.9095C2.46132 56.8747 2.4867 56.8395 2.51231 56.804C3.06386 56.039 3.72281 55.1124 4.42515 54.0983C4.67258 53.741 4.92538 53.3729 5.18077 52.9971C6.24438 51.4321 7.35285 49.7348 8.30401 48.1386C3.44192 43.4123 0.5 37.2469 0.5 30.5029C0.5 15.6203 14.8269 3.55554 32.5 3.55554C50.1731 3.55554 64.5 15.6203 64.5 30.5029C64.5 45.3855 50.1731 57.4502 32.5 57.4502C27.9798 57.4502 23.6784 56.6609 19.7797 55.2372C16.173 57.3046 12.9337 58.6182 9.36614 59.4411ZM13.2606 43.0396C15.0498 44.7788 15.7568 47.2764 15.2609 49.6151C15.5843 49.4403 15.9115 49.258 16.2434 49.0677C18.0626 48.0249 20.2494 47.8382 22.2191 48.5575C25.3318 49.6943 28.8072 50.3391 32.5 50.3391C47.4399 50.3391 57.3889 40.362 57.3889 30.5029C57.3889 20.6438 47.4399 10.6667 32.5 10.6667C17.5601 10.6667 7.61111 20.6438 7.61111 30.5029C7.61111 35.083 9.59133 39.4727 13.2606 43.0396Z",
    fill: "#5F6F7C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIconLarge);
export default __webpack_public_path__ + "static/media/comment-icon-large.040d1ba87e07c4703e5a76d9116cc0b7.svg";
export { ForwardRef as ReactComponent };